import React, { useContext, useState } from "react";
import LinkForm from "./../components/Linkestan/LinkForm";
import LinkUploadMedia from "./../components/Linkestan/LinkUploadMedia";
import { Button, Steps, theme } from "antd";
import { useNavigate } from "react-router";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";

const steps = [
    {
        title: "ویرایش جزئیات لینک",
        content: <LinkForm />,
    },
    {
        title: "انتخاب عکس",
        content: <LinkUploadMedia />,
    },
];
const EditLink = () => {
    const { token } = theme.useToken();
    // state
    const [current, setCurrent] = useState(0);
    // context
    const {
        setLinkCover,
        setLinkMedia,
        selectedLinkId,
        newLinks,
        textEditorHTML,
        linkestanIcon,
        linkTitle,
        linkCoverId,
        linkMediaId,
        linkestanTags,
        setLinkMediaId,
    } = useContext(context);
    // functions
    const next = () => {
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSubmit = () => {
        http.post(
            `${config.parkopoloApi}/api/Link/editLink/${selectedLinkId}`,
            {
                links: newLinks,
                data: textEditorHTML,
                title: linkTitle,
                icon: linkestanIcon,
                coverPic: linkCoverId,
                media: linkMediaId,
                tags: linkestanTags,
            }
        )
            .then((res) => {
                toast.success("لینک با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setLinkMedia([]);
        setLinkMediaId([]);
        setLinkCover();
        navigate("/linkestan", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    gap: "10px",
                    display: "flex",
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            current === 0 && (!linkTitle || linkTitle === "")
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        disabled={!linkCoverId || linkCoverId === ""}
                        type="primary"
                        onClick={() => handleSubmit()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/linkestan">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
            </div>
        </div>
    );
};

export default EditLink;
